"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapShipmentCommentApiToSdk = function (apiData) {
    var timestamp = apiData.createdAt;
    return Object.assign({}, apiData, { timestamp: timestamp });
};
